/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Spaces_Tip_Drag_DropInputs */



/**
* | output |
* | --- |
* | "💡 Tip: Drag and drop files or folders here to upload them to {target}" |
*
* @param {Spaces_Tip_Drag_DropInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tip_drag_drop = /** @type {((inputs: Spaces_Tip_Drag_DropInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tip_Drag_DropInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`💡 Tipp: Ziehe Dateien oder Ordner hierher, um sie hochzuladen: ${i?.target}`)
	return /** @type {LocalizedString} */ (`💡 Tip: Drag and drop files or folders here to upload them to ${i?.target}`)
});